<template>
  <div class="card-body">
    <!-- Filtros -->
    <div class="row mb-3">
      <div class="col-md-3">
        <label class="form-label text-muted">Data Início</label>
        <input type="date" class="form-control" v-model="filters.date_start" />
      </div>
      <div class="col-md-3">
        <label class="form-label text-muted">Data Fim</label>
        <input type="date" class="form-control" v-model="filters.date_end" />
      </div>
      <div class="col-md-3">
        <label class="form-label text-muted">Status</label>
        <select class="form-select" v-model="filters.status">
          <option value="">Todos</option>
          <option value="aguardando">Aguardando</option>
          <option value="agendado">Agendado</option>
          <option value="em andamento">Em andamento</option>
          <option value="concluido">Concluída</option>
          <option value="cancelado">Cancelada</option>
          <option value="recusado">Recusado</option>
        </select>
      </div>
      <div class="col-md-3 d-flex align-items-end">
        <button
          class="btn btn-primary w-100"
          @click="loadAppointments"
          :disabled="loading"
        >
          <i class="fa-solid fa-filter me-1"></i>
          Filtrar
        </button>
      </div>
    </div>

    <LoadingContainer v-if="loading || !hasLoaded" />

    <EmptyState
      v-else-if="appointments.length === 0"
      :msg="' '"
      :title="'Nenhuma sessão encontrada'"
    />

    <div v-else>
      <table class="table table-borderless table-hover table-sm">
        <TableHead :columns="columns" />
        <tbody>
          <router-link
            v-for="(schedule, index) in appointments"
            :key="'hr-' + index"
            :to="`${$paths.appointments.detail}/${schedule.id}`"
            tag="tr"
            role="button"
          >
            <td>{{ schedule.id }}</td>
            <td>
              {{ schedule.psychologist?.name }}
            </td>
            <td>{{ schedule.formatted_date }}</td>
            <td>{{ schedule.formatted_type }}</td>
            <td>
              <span :class="schedule.statusObject?.badgeClass">
                {{ schedule.statusObject?.title }}
              </span>
            </td>
            <td class="text-end">
              {{ schedule.paymentStatus?.title }}
            </td>
            <td class="text-end">
              <router-link
                class="btn btn-sm btn-white lift"
                :to="`${$paths.appointments.detail}/${schedule.id}`"
                target="_blank"
              >
                <span class="fe fe-arrow-up-right"></span>
              </router-link>
            </td>
          </router-link>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: "UserDetailAppointments",
  props: {
    userId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      hasLoaded: false,
      appointments: [],
      filters: {
        date_start: "",
        date_end: "",
        status: "",
      },
      columns: [
        {
          name: "ID",
          sortName: null,
          order: null,
        },
        {
          name: "Psicólogo",
          sortName: null,
          order: null,
        },
        {
          name: "Data",
          sortName: null,
          order: null,
        },
        {
          name: "Tipo",
          sortName: null,
          order: null,
        },
        {
          name: "Status",
          sortName: null,
          order: null,
        },
        {
          name: "Pagamento",
          sortName: null,
          order: null,
        },
      ],
    };
  },
  mounted() {
    // Definir datas padrão
    this.filters.date_start = this.getDefaultStartDate();
    this.filters.date_end = this.getDefaultEndDate();
  },
  methods: {
    getDefaultStartDate() {
      // 45 dias atrás
      const date = this.$moment().subtract(45, "days");
      return date.format("YYYY-MM-DD");
    },
    getDefaultEndDate() {
      // 45 dias no futuro
      const date = this.$moment().add(45, "days");
      return date.format("YYYY-MM-DD");
    },
    async loadAppointments() {
      if (!this.userId) return;

      this.loading = true;
      try {
        const params = {
          user_id: this.userId,
        };

        // Adicionar filtros se existirem
        if (this.filters.date_start) {
          params.date_start = this.filters.date_start;
        }
        if (this.filters.date_end) {
          params.date_end = this.filters.date_end;
        }
        if (this.filters.status) {
          params.status = this.filters.status;
        }

        const response = await this.$appointmentsService.list(params);

        // Preparar dados de cada appointment usando o método do service
        this.appointments = response.data.map((appointment) => {
          return this.$appointmentsService.prepareAppointment(appointment);
        });
      } catch (error) {
        console.error("Erro ao carregar sessões:", error);
        this.$eventBus.$emit("showToast", {
          title: "Erro",
          msg: error.message || "Erro ao carregar sessões",
        });
      } finally {
        this.loading = false;
        this.hasLoaded = true;
      }
    },
  },
};
</script>
